/**
 * Envío MC-2 · permisos de Claude (MCP) sobre proyectos hechos en la app.
 * Todo con la sesión del usuario (el token lo agrega AuthSetup).
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/mcp-access`;

export const claudeAccessService = {
  async pending() {
    const res = await axios.get(`${API}/pending`);
    return res.data.pending || [];
  },
  async grants() {
    const res = await axios.get(`${API}/grants`);
    return res.data.grants || [];
  },
  async approve(id, duration) {
    const res = await axios.post(`${API}/${id}/approve`, { duration });
    return res.data.grant;
  },
  async deny(id) {
    await axios.post(`${API}/${id}/deny`);
  },
  async revoke(id) {
    await axios.post(`${API}/${id}/revoke`);
  },
  async restore(id) {
    const res = await axios.post(`${API}/${id}/restore`);
    return res.data;
  },
};

/** «Hasta las 18:40» / «Siempre en este proyecto». */
export function grantLabel(g, now = new Date()) {
  if (!g) return '';
  if (g.duration === 'project' || !g.expires_at) return 'Siempre en este proyecto';
  const exp = new Date(g.expires_at);
  if (Number.isNaN(exp.getTime())) return 'Por 1 hora';
  const mins = Math.max(0, Math.round((exp - now) / 60000));
  const hhmm = exp.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });
  return mins > 0 ? `Hasta las ${hhmm} (quedan ${mins} min)` : 'Vencido';
}

/** Permisos activos sobre un proyecto (para saber si conviene sincronizar en vivo). */
export function hasActiveGrant(grants, projectId, now = new Date()) {
  return (grants || []).some((g) => g.project_id === projectId
    && (g.duration === 'project' || !g.expires_at || new Date(g.expires_at) > now));
}
